import { makeStyles } from "@mui/styles";
import workImg from "assets/images/work-login-unsplash.jpg";
import { ORGANISATION_DEFAULTS } from "utils/constants";

const styles = {
    root: {
        maxWidth: 294,
        height: "125%",
        margin: "-32px 16px -16px -32px",
        position: "relative"
    },
    img: {
        width: "100%",
        height: "100%",
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
        background:
            "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.6))"
    },
    tagLine: {
        marginLeft: 16,
        position: "absolute",
        bottom: "10%",
        color: "white",
        fontWeight: "bold",
        textShadow: "1px 1px 3px rgba(0, 0, 0, 0.6)"
    },
    tagLineTop: {
        marginLeft: 16,
        position: "absolute",
        top: "5%",
        color: "#FFA500",
        fontWeight: "bold",
        textShadow: "1px 1px 3px rgba(0, 0, 0, 0.6)",
        fontSize: 16,
        display: "flex",
        alignItems: "center",
        flexDirection: "column"
    }
};

const useStyles = makeStyles(styles);

function SideCard() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <img className={classes.img} alt="loading" src={workImg} />
            <div className={classes.tagLine}>
                We effect positive change through design.
            </div>
            <div className={classes.tagLineTop}>
                {ORGANISATION_DEFAULTS.orgName}
            </div>
        </div>
    );
}

export default SideCard;
